import { Box, alpha, InputLabel, Typography, colors as muiColors, Tooltip } from '@mui/material'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import InstitutionSelectorAutocomplete from './InstitutionSelectorAutocomplete'

const useStyles = makeStyles((theme) => ({
  institutionSelector: {
    padding: theme.spacing(0.25, 0, 0.25, 1),
    color: theme.palette.primary.main,
    borderRadius: theme?.custom?.app.input.borderRadius,
    backgroundColor: muiColors.grey[50],
    fontSize: `
      clamp(${theme.typography.pxToRem(12)}, 
      ${theme?.custom?.app.scaleFactor.default},
      ${theme.typography.pxToRem(16)})
    `,
    minWidth: theme.spacing(34),
    transition: theme.transitions.create('background-color', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shortest,
    }),
    '& .MuiAutocomplete-inputRoot': {
      color: 'inherit',
      backgroundColor: 'transparent',
      boxShadow: 'none',
      fontWeight: theme.typography.fontWeightBold,
      '&:focus, &:focus-within': {
        boxShadow: 'none',
      },
      '& .MuiInput-input': {
        boxShadow: 'inherit',
      },
    },
    '&:hover, &:focus-within': {
      backgroundColor: alpha(theme.palette.primary.light, 0.1),
    },
    '&:focus-within': {
      boxShadow: theme?.custom?.app.input.focus.boxShadow,
    },
  },
}))

const InstitutionSelectorDesktop = ({ options, defaultValue, onSelectInstitution }) => {
  const { institutionSelector } = useStyles()

  return (
    <Box display="flex" alignItems="center" className={institutionSelector}>
      <Tooltip title="Werk je bij meerdere scholen, dan kun je hier wisselen van schoolomgeving">
        <Box display="inherit" alignItems="inherit">
          <InputLabel htmlFor="institution-name" shrink={false}>
            <Typography variant="caption" component="span">
              School:
            </Typography>
          </InputLabel>
        </Box>
      </Tooltip>
      <InstitutionSelectorAutocomplete
        options={options}
        defaultValue={defaultValue}
        onSelectInstitution={onSelectInstitution}
      />
    </Box>
  )
}
InstitutionSelectorDesktop.propTypes = {
  options: PropTypes.any,
  defaultValue: PropTypes.any,
  onSelectInstitution: PropTypes.any,
}

export default InstitutionSelectorDesktop
